import { useGetMainFilterApplied, useGetPathFilterApplied } from '../publicCatalogFiltersHooks';
import { useGetResultsDisplay } from '../publicCatalogPaginationHooks';
import { PAGE_SIZE } from './PublicCatalogResults';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicCatalogResultsText = ({
  count
}) => {
  const mainFilterApplied = useGetMainFilterApplied();
  const pathFilterApplied = useGetPathFilterApplied();
  const {
    minResult,
    maxResult
  } = useGetResultsDisplay(PAGE_SIZE, count);
  return /*#__PURE__*/_jsxs("div", {
    children: [count > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.catalogPage.filters.resultsDisplay",
      options: {
        start: minResult,
        end: maxResult,
        count
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyPublic.catalogPage.filters.noResults"
    }), mainFilterApplied || pathFilterApplied ? ':' : '']
  });
};
export default PublicCatalogResultsText;